// __webpack_require__.p is used as baseURL for any require()'d asset
// It is set automatically by Yoshi, but in case if win.__STATICS_BASE_URL__ exists - it will be used instead of correct one
// Widget is rendered inside a page that doesn't belong to us, thus it might host its own __STATICS_BASE_URL__, which
// won't work for us. Thus patching.
export const patchWebpackPublicPath = (widgetStaticsBaseUrl: string) => {
  if (typeof __webpack_require__ !== 'undefined') {
    __webpack_require__.p = widgetStaticsBaseUrl;
  }
};
